"use client";

import HomeHeader from "../HomePage/components/HomeHeader";
import Paper from "../../components/oca/Paper";
import Intro from "../../components/oca/Intro";
import Feature from "../../components/oca/Feature";
import Core from "../../components/oca/Core";
import UseCase from "../../components/oca/UseCase";
import GettingStarted from "../../components/oca/GettingStarted";
import Partners from "../../components/oca/Partners";

export default function OcaPage() {
  return (
    <>
      {/* Redesigned Figma-styled pill header (same one used on the homepage). */}
      <HomeHeader />
      {/* Spacer so the intro clears the fixed pill (top 24px + 82px tall). */}
      <div className="oca-header-spacer" />
      <Paper>
        <Intro />
        <Feature />
        <Core />
        <UseCase />
        <GettingStarted />
        <Partners />
      </Paper>
    </>
  );
}
